export const whatsappUrl =
  "https://wa.me/6281215511551?text=I'd like to know more about booking a Professional Disinfection from Disinfection2U";
